import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Axios from 'axios';
import { API_CONFIG } from "../../../config/config.jsx";
import ReactTable from "react-table";
import matchSorter from 'match-sorter'
import { connect } from 'react-redux';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import DownloadIcon from "assets/img/DownloadIcon.png";
import DateRange from "./DateRange.jsx";
import IncomeReport from './IncomeReport.jsx';

const styles = theme => ({
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "0px",
      textDecoration: "none",
      "& small": {
        color: "#777",
        fontSize: "65%",
        fontWeight: "400",
        lineHeight: "1"
      }
    },
    root: {
      flexGrow: 1,
      width: "100%",
      marginTop: theme.spacing.unit * 3,
      overflowX: "auto"
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 120
    },
    title: {
      fontSize: 14
    },
    downloadStyle: {
      width: 20,
      height: 20,
      marginLeft: "80%",
      cursor: "pointer",
      marginBottom: "2px"
    }
  });
class IncomeReportByStore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            storeIncomeData: [],
            pickUpData: [],
            showTable: false,
            userData: [],
            showReport: false,
            startDate: "",
            endDate: "",
        };
    }
    showReport = () => {
        this.setState({
          showReport: true
        });
      };
      showDefaultReport = showDefaultReport => {
        this.setState({
          showReport: showDefaultReport
        });
      };
      fetchStandardReportData = (startDate, endDate, showReport) => {
        this.setState({
          startDate: startDate,
          endDate: endDate,
          showReport: showReport
        });
      };
    fetchData = () => {
        const token = sessionStorage.getItem("plugoAuthKey");
        const userId = sessionStorage.getItem('plugoUserId');
        Axios.get(`${API_CONFIG.HOST}/store-report/${userId}`,
        {
            headers: {
              "Authorization": `Bearer ${token}`,
              "X-USER-ID": userId
            }
          }
        )
            .then(res => {
                this.setState({
                    pickUpData: res.data
                });

            });
    }

    render() {
        const { classes } = this.props;
        const onRowClick = (state, rowInfo, column, instance) => {
            return {
                onClick: e => {
                    // this.handleStore(rowInfo)
                    // this.setState({
                    //     showTable: true
                    // });
                    console.log('it produced this event:', state)
                    console.log('It was in this column:', column)
                    console.log('It was in this row:', rowInfo.original)
                    console.log('It was in this table instance:', instance)
                    const storeId = rowInfo.original.storeId

                }
            }
        }
        let pickUpData = this.state.pickUpData.map((row, index) => {
            return {
                pincode: row.pincode,
                storeName: row.Store_Name,
                dailyTotalUser: row.Rental_Data.Daily_report.totalRentals,
                dailyStandardUser:row.Rental_Data.Daily_report.standardUsers,
                dailyPremiumUser:row.Rental_Data.Daily_report.premiumUsers,

                weeklyTotalUser: row.Rental_Data.Weekly_report.totalRentals,
                weeklyStandardUser: row.Rental_Data.Weekly_report.standardUsers,
                weeklyPremiumUser: row.Rental_Data.Weekly_report.premiumUsers,

                monthlyTotalUser: row.Rental_Data.Monthly_report.totalRentals,
                monthlyStandardUser: row.Rental_Data.Monthly_report.standardUsers,
                monthlyPremiumUsers: row.Rental_Data.Monthly_report.premiumUsers
            }
        });

        return (
            <div>
              <Card>
          <CardHeader color="success">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <h4 className={classes.cardTitleWhite}>User Details By Stores</h4>
              <img
                onClick={this.handleExcel}
                title="Download as Excel"
                className={classes.downloadStyle}
                src={DownloadIcon}
              />
            </div>
          </CardHeader>
          <CardBody>
            <DateRange
              showReport={this.showReport}
              showDefaultReport={this.showDefaultReport}
              fetchStandardReportData={this.fetchStandardReportData}
            />
             {this.state.showReport ? (
                console.log("ddd"),
                <IncomeReport
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                />
              
            ) : (
         

                <ReactTable
                    data={pickUpData}
                    onFetchData={this.fetchData}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                        {
                            columns: [
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Pincode",
                                    minWidth: 10,
                                    id: "pincode",
                                    accessor: d => d.pincode,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["pincode"] }),
                                    filterAll: true

                                }
                            ]
                        },
                        {
                            columns: [
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Store Name",
                                    minWidth: 10,
                                    id: "storeName",
                                    accessor: d => d.storeName,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["storeName"] }),
                                    filterAll: true

                                }
                            ]
                        },
                        {
                            Header: "Daily User",
                            columns: [
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Total Rentals",
                                    minWidth: 10,
                                    id: "dailyTotalUser",
                                    accessor: d => d.dailyTotalUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["dailyTotalUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Standard Users",
                                    minWidth: 10,
                                    id: "dailyStandardUser",
                                    accessor: d => d.dailyStandardUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["dailyStandardUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Premium Users",
                                    minWidth: 10,
                                    id: "dailyPremiumUser",
                                    accessor: d => d.dailyPremiumUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["dailyPremiumUser"] }),
                                    filterAll: true
                                }
                            ]
                        },
                        {
                            Header: "Weekly User",
                            columns: [
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Total Rentals",
                                    minWidth: 10,
                                    id: "weeklyTotalUser",
                                    accessor: d => d.weeklyTotalUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["weeklyTotalUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Standard Users",
                                    minWidth: 10,
                                    id: "weeklyStandardUser",
                                    accessor: d => d.weeklyStandardUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["weeklyStandardUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Premium Users",
                                    minWidth: 10,
                                    id: "weeklyPremiumUser",
                                    accessor: d => d.weeklyPremiumUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["weeklyPremiumUser"] }),
                                    filterAll: true
                                }
                            ]
                        },
                        {
                            Header: "Monthly User",
                            columns: [
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Total Rentals",
                                    minWidth: 10,
                                    id: "monthlyTotalUser",
                                    accessor: d => d.monthlyTotalUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["monthlyTotalUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Standard Users",
                                    minWidth: 10,
                                    id: "monthlyStandardUser",
                                    accessor: d => d.monthlyStandardUser,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["monthlyStandardUser"] }),
                                    filterAll: true
                                },
                                {
                                    headerStyle: { fontSize: '16px', height: '40px', paddingTop: '10px' },
                                    style: { textAlign: "center" },
                                    Header: "Premium Users",
                                    minWidth: 10,
                                    id: "monthlyPremiumUsers",
                                    accessor: d => d.monthlyPremiumUsers,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, { keys: ["monthlyPremiumUsers"] }),
                                    filterAll: true
                                }
                            ]
                        },
                    ]}
                    // defaultPageSize={10}
                    className="-striped -highlight"
                    getTrProps={onRowClick}
                />
                )}
                </CardBody>
                </Card>
            </div>
        );
    }

}
IncomeReportByStore.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
    city: state.city.city,
  });
  
  export default connect(
    mapStateToProps,
    null,
    null,
    { pure: false }
  )(withStyles(styles)(IncomeReportByStore));